import { OPERTO_TRPC_URL } from '@/assets/configurations/Settings';
import type {
  CompanyProvider,
  Verification,
} from '@operto/verifications-shared';
import { RTKQapi } from '../rtkq-api';
import { ResponseData } from '../rtkq-utils';

export const TAG = 'VERIFICATIONS';

type ChekinSdkApiKey = {
  sdkApiKey: string;
};

const apiWithTag = RTKQapi.enhanceEndpoints({
  addTagTypes: [TAG],
});

export const verificationsApi = apiWithTag.injectEndpoints({
  endpoints: builder => ({
    getCompanyProvider: builder.query<
      ResponseData<CompanyProvider>,
      { id: string | number }
    >({
      query: ({ id }) => ({
        url: `${OPERTO_TRPC_URL}/verifications/companies/${id}/providers`,
        method: 'GET',
      }),
    }),
    getVerificationStatus: builder.query<
      ResponseData<Verification>,
      { reservationId: string }
    >({
      query: ({ reservationId }) => ({
        url: `${OPERTO_TRPC_URL}/verifications/reservations/${reservationId}/status`,
        method: 'GET',
      }),
    }),
    getChekinSdkApiKey: builder.query<
      ResponseData<ChekinSdkApiKey>,
      { id: string | number }
    >({
      query: ({ id }) => ({
        url: `${OPERTO_TRPC_URL}/verifications/companies/${id}/chekin-sdk-api-key?type=guests`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetCompanyProviderQuery,
  useGetVerificationStatusQuery,
  useGetChekinSdkApiKeyQuery,
  useLazyGetCompanyProviderQuery,
  useLazyGetVerificationStatusQuery,
  useLazyGetChekinSdkApiKeyQuery,
} = verificationsApi;
